export const GET_SUCCESS_STORIES = 'successStories/GET_SUCCESS_STORIES';



// WEBPACK FOOTER //
// ./src/redux/SuccessStories/constants.js